var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeatOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77,91 L21,91 L21,99 L17,99 L17,91 L14,91 C9.02943725,91 5,86.9705627 5,82 L5,50 C5,45.0294373 9.02943725,41 14,41 L86,41 C90.9705627,41 95,45.0294373 95,50 L95,82 C95,86.9705627 90.9705627,91 86,91 L81,91 L81,99 L77,99 L77,91 Z M23,50 C21.8954305,50 21,50.8954305 21,52 L21,79 C21,80.1045695 21.8954305,81 23,81 C24.1045695,81 25,80.1045695 25,79 L25,52 C25,50.8954305 24.1045695,50 23,50 Z M32,50 C30.8954305,50 30,50.8954305 30,52 L30,79 C30,80.1045695 30.8954305,81 32,81 C33.1045695,81 34,80.1045695 34,79 L34,52 C34,50.8954305 33.1045695,50 32,50 Z M41,50 C39.8954305,50 39,50.8954305 39,52 L39,79 C39,80.1045695 39.8954305,81 41,81 C42.1045695,81 43,80.1045695 43,79 L43,52 C43,50.8954305 42.1045695,50 41,50 Z M50,50 C48.8954305,50 48,50.8954305 48,52 L48,79 C48,80.1045695 48.8954305,81 50,81 C51.1045695,81 52,80.1045695 52,79 L52,52 C52,50.8954305 51.1045695,50 50,50 Z M59,50 C57.8954305,50 57,50.8954305 57,52 L57,79 C57,80.1045695 57.8954305,81 59,81 C60.1045695,81 61,80.1045695 61,79 L61,52 C61,50.8954305 60.1045695,50 59,50 Z M68,50 C66.8954305,50 66,50.8954305 66,52 L66,79 C66,80.1045695 66.8954305,81 68,81 C69.1045695,81 70,80.1045695 70,79 L70,52 C70,50.8954305 69.1045695,50 68,50 Z M77,50 C75.8954305,50 75,50.8954305 75,52 L75,79 C75,80.1045695 75.8954305,81 77,81 C78.1045695,81 79,80.1045695 79,79 L79,52 C79,50.8954305 78.1045695,50 77,50 Z",
    id: "Combined-Shape",
    fill: "#D0021B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,11.7388032 C14.328665,13.1150322 13.2429974,15.1686489 13.2429974,17.8996532 C13.2429974,26.1262305 19.7434219,22.298264 19.7434219,27.8131127 C19.7434219,31.1899648 18.6622812,33.7522606 16.5,35.5",
    id: "Line",
    stroke: "#D0021B",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5,11.7388032 C34.328665,13.1150322 33.2429974,15.1686489 33.2429974,17.8996532 C33.2429974,26.1262305 39.7434219,22.298264 39.7434219,27.8131127 C39.7434219,31.1899648 38.6622812,33.7522606 36.5,35.5",
    id: "Line",
    stroke: "#D0021B",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5,11.7388032 C54.328665,13.1150322 53.2429974,15.1686489 53.2429974,17.8996532 C53.2429974,26.1262305 59.7434219,22.298264 59.7434219,27.8131127 C59.7434219,31.1899648 58.6622812,33.7522606 56.5,35.5",
    id: "Line",
    stroke: "#D0021B",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5,11.7388032 C74.328665,13.1150322 73.2429974,15.1686489 73.2429974,17.8996532 C73.2429974,26.1262305 79.7434219,22.298264 79.7434219,27.8131127 C79.7434219,31.1899648 78.6622812,33.7522606 76.5,35.5",
    id: "Line",
    stroke: "#D0021B",
    strokeWidth: 3,
    strokeLinecap: "square"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatOn);
export default __webpack_public_path__ + "static/media/heat_on.944e55ba71179fb2fcee839bcb84bc74.svg";
export { ForwardRef as ReactComponent };